import React from 'react'
import { isBrowser, isMobile } from "react-device-detect";
import { Toast } from 'antd-mobile';
import { notification } from 'antd';
export const MsgBox = (props) => {
  if (isBrowser) {
    if (props.type == 'success') {
      return notification.success({
        message: props.message,
        description: props.description,
      });
    }
    else if (props.type == 'error') {
      return notification.error({
        message: props.message,
        description: props.description,
      })
    }
  }
  else if (isMobile) {
    if (props.type == 'success') {
      return Toast.success(props.description, 5)
    }
    else if (props.type == 'error') {
      return Toast.fail(props.description, 5)
    }
  }
}
